import React from 'react';
import MainBackground from './background';
import MainContent from './content';

export type BgMode =
  | 'pick'
  | 'cream'
  | 'market'
  | 'fight'
  | 'center'
  | 'inactive';

interface Props {
  children: React.ReactNode;
  mode: BgMode;
}

const MainBackgroundWrapper = ({ children, mode }: Props) => (
  <>
    <MainBackground mode={mode} />
    <MainContent mode={mode} children={children} />
  </>
);

export default MainBackgroundWrapper;
